export const PROVISION_MAX_TOTAL = 60;

export const ALL_PROVISION_OPTIONS = Array.from({ length: 11 }, (_, i) => 50 - i * 5);

export type ProvisionField = 'provisionDienstleistung' | 'provisionVerkauf';

export interface HalbjahrProvision {
    provisionDienstleistung?: number;
    provisionVerkauf?: number;
}

export const getProvisionOptions = (
    halbjahrData: HalbjahrProvision,
    field: ProvisionField
): number[] => {
    const otherField: ProvisionField = field === 'provisionDienstleistung' ? 'provisionVerkauf' : 'provisionDienstleistung';
    const otherValue = halbjahrData[otherField] ?? 0;
    const currentValue = halbjahrData[field] ?? 0;
    const maxForField = PROVISION_MAX_TOTAL - otherValue;

    const filtered = ALL_PROVISION_OPTIONS.filter((opt) => opt <= maxForField);

    if (!filtered.includes(currentValue) && currentValue >= 0) {
        return [...filtered, currentValue].sort((a, b) => b - a);
    }

    return filtered;
};

export const applyProvisionChange = (
    halbjahrData: HalbjahrProvision,
    field: ProvisionField,
    newValue: number
): HalbjahrProvision => {
    const otherField: ProvisionField = field === 'provisionDienstleistung' ? 'provisionVerkauf' : 'provisionDienstleistung';
    const otherValue = halbjahrData[otherField] ?? 0;
    const maxAllowed = Math.max(0, PROVISION_MAX_TOTAL - otherValue);
    const value = Math.max(0, Math.min(newValue, maxAllowed));

    const next: HalbjahrProvision = {
        ...halbjahrData,
        [field]: value,
    };

    const sum = (next.provisionDienstleistung ?? 0) + (next.provisionVerkauf ?? 0);
    if (sum > PROVISION_MAX_TOTAL) {
        next[otherField] = PROVISION_MAX_TOTAL - value;
    }

    return next;
};
